import React from "react";
import { useNavigate } from "react-router-dom";

const ArticleBox = ({ blog }) => {
  const navigate = useNavigate();

  return (
    <article
      key={blog.id}
      className="rounded-2xl border bg-white p-4 shadow-sm"
    >
      <img
        src={blog.image}
        alt={blog.title}
        className="h-40 w-full object-cover rounded-md"
      />
      <div className="mt-3 flex items-start justify-between">
        <div>
          <span className="inline-block rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-600">
            {blog.tag}
          </span>
          <h3 className="mt-2 text-lg font-semibold text-slate-900">
            {blog.title}
          </h3>
          <p className="mt-2 text-sm text-slate-600">
            {blog.description.slice(0, 100)}
          </p>
        </div>
        <div className="text-xs text-slate-400">{blog.postedOn}</div>
      </div>

      <button
        className="text-sm font-medium text-[#064585]"
        onClick={() => {
          navigate(`/articles/${blog.id}`);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        Read more →
      </button>
    </article>
  );
};

export default ArticleBox;
